import { useT } from "@/lib/LanguageContext";

const CONTACT_EMAIL = "hello@veronikaconk.com";

export default function Footer() {
  const { t } = useT();
  const f = t.footer;

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#3A1E3D] text-[#F7F3F7] pt-24 pb-10 vk-grain overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 md:gap-12 pb-16 border-b border-[#F7F3F7]/15">
          <div className="col-span-12 md:col-span-7">
            <p className="text-[11px] uppercase tracking-[0.3em] text-[#E0B25B] mb-5">
              VeronikaconK
            </p>
            <h3
              data-testid="footer-tagline"
              className="font-serif font-light text-3xl md:text-5xl leading-tight tracking-tight max-w-xl"
            >
              {f.tagline}
            </h3>
            <p className="mt-8 font-serif italic text-2xl md:text-3xl text-[#E0B25B] leading-snug">
              {f.brandLine}
            </p>
          </div>

          <div className="col-span-12 md:col-span-4 md:col-start-9 self-end">
            <p className="text-[11px] uppercase tracking-[0.24em] text-[#F7F3F7]/60 mb-3">
              {f.contactLabel}
            </p>
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              data-testid="footer-email"
              className="vk-underline font-serif text-2xl md:text-3xl break-all"
            >
              {CONTACT_EMAIL}
            </a>
            <p className="mt-6 text-[12px] tracking-[0.04em] text-[#F7F3F7]/70">
              {f.languages}
            </p>
          </div>
        </div>

        <div className="py-16 select-none overflow-hidden">
          <p
            data-testid="footer-mega"
            className="font-serif font-light vk-mega-text text-center text-[#F7F3F7]"
          >
            VeronikaconK
          </p>
        </div>

        <div className="text-center text-[11px] uppercase tracking-[0.22em] text-[#F7F3F7]/50">
          <p>© {new Date().getFullYear()} VeronikaconK · {f.rights}</p>
        </div>
      </div>
    </footer>
  );
}
